import './App.scss';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Header from './app/layout/Header';
import ProductLabelPage from './app/pages/ProductLabelPage';
import OutboundPalletsLabelPage from './app/pages/OutboundPalletsLabelPage';
import ProductionHoldPage from './app/pages/ProductionHoldPage';
import PalletProCarrierLabelPage from './app/pages/PalletProCarrierLabelPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import ProductionPalletsLabelPage from './app/pages/ProductionPalletsLabelPage';
import SignIn from './app/components/user/SignIn';

import useSignInHook from './redux/hooks/useSignInHook';
import FnSkuLabelPage from './app/pages/FnSkuLabelPage';
import LiquidationLabelGeneratorPage from './app/pages/LiquidationLabelGeneratorPage';

function App() {
  const { user, signIn, signOut } = useSignInHook();

  return (
    <div className="h-screen base-card">
      <div className="App">
        {user == null ? (
          <SignIn signIn={signIn} />
        ) : (
          <BrowserRouter>
            <Header signOut={signOut} />
            <div className="flex flex-1 h-full p-5 pt-0 dark:bg-gray-800">
              <Routes>
                <Route path="/fnsku-product-label" element={<FnSkuLabelPage />}/>

                <Route path="/batchid/:batchid" element={<ProductLabelPage />} />
                <Route path="/label-generator" element={<ProductLabelPage />} />
                <Route path="/" element={<ProductLabelPage />} />

                {/* Outbound pallet label */}
                <Route path="/outbound-pallets-generator" element={<OutboundPalletsLabelPage />} />
                <Route path="/outboundpalletlabels" element={<OutboundPalletsLabelPage />}>
                  <Route path=":shipmentName" />
                </Route>

                {/* Pro pallet label */}
                <Route path="/pro-pallets-generator" element={<PalletProCarrierLabelPage />} />
                <Route path="/propalletlabels" element={<PalletProCarrierLabelPage />}>
                  <Route path=":shipmentName" />
                </Route>

                {/* Proudction pallet label */}
                <Route
                  path="/production-pallets-generator"
                  element={<ProductionPalletsLabelPage />}
                />
                <Route path="/productionpalletlabels" element={<ProductionPalletsLabelPage />}>
                  <Route path=":shipmentName" />
                </Route>

                <Route path="/liquidation" element={<LiquidationLabelGeneratorPage />} />

                <Route path="/productionhold/batchid/:batchid" element={<ProductionHoldPage />} />
                <Route path="/productionhold" element={<ProductionHoldPage />} />

                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
            <ToastContainer hideProgressBar={true} autoClose={3000} />
          </BrowserRouter>
        )}
      </div>
    </div>
  );
}

export default App;
